const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/sales/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import i18n from "@/lib/i18n";
import { httpClient } from "@/lib/http-client";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/sales/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context
  }) => {
    const {
      queryClient
    } = context;
    await queryClient.prefetchQuery({
      queryKey: ["active-sales"],
      queryFn: () => httpClient.get<{
        id: string;
        name: string;
        active: boolean;
        offers: SingleOffer[];
      }[]>("/active-sales").catch(() => [])
    });
    return {
      dehydratedState: dehydrate(queryClient)
    };
  },
  head: () => {
    return {
      meta: [{
        title: i18n.t("sales.metaIndex.title")
      }, {
        name: "description",
        content: i18n.t("sales.metaIndex.description")
      }, {
        name: "og:title",
        content: i18n.t("sales.metaIndex.title")
      }, {
        name: "og:description",
        content: i18n.t("sales.metaIndex.description")
      }, {
        property: "twitter:title",
        content: i18n.t("sales.metaIndex.title")
      }, {
        property: "twitter:description",
        content: i18n.t("sales.metaIndex.description")
      }]
    };
  }
});